import angular from 'angular';

angular
  .module('cxRelations')
  .factory('relPersistSvc', [
    'resourceFactorySvc',
    '$q',
    '$filter',
    'flySvc',
    'relBindSvc',
    'dataCache',
    'recentRelationsSvc',
    '$http',
    'appUrls',
    'dialogsSvc',
    'relBudgetSvc',
    relPersistSvc,
  ]);

function relPersistSvc(
  resourceFactory,
  $q,
  $filter,
  flySvc,
  relBindSvc,
  dataCache,
  recentRelationsSvc,
  $http,
  appUrls,
  dialogsSvc,
  relBudgetSvc,
) {
  // This service always saves a list of fields !
  // get the resourceObject
  var resource = resourceFactory.get('relation');
  var fieldReqResource = resourceFactory.get('fieldRequired');

  var recalcFiscalYearDeadlines = function(relationId) {
    const recalcDeadlinesParams = {
      relationId,
      onlyBasedOnFiscalYears: true,
      recalcSubtasks: true,
    };
    return $http
      .post(`${appUrls.tasks}/api/plannedTasks/RecalculateDeadlinesCount`, recalcDeadlinesParams)
      .then(({ data }) => {
        if (!data) return;
        return dialogsSvc
          .showYesNo('msgRecalcDeadlinesTitle', 'msgRecalcDeadlinesMessage', { count: data })
          .then(
            function() {
              return $http
                .post(
                  `${appUrls.tasks}/api/plannedTasks/RecalculateDeadlines`,
                  recalcDeadlinesParams,
                )
                .then(
                  ({ data }) => {
                    if (data && data.id) {
                      flySvc.action('msgJobStarted', undefined, 'jobs.detail', undefined, {
                        jobId: data.id,
                      });
                    }
                  },
                  error => {
                    flySvc.error(error);
                  },
                );
            },
            function() {
              //Don't recalc
              return undefined;
            },
          );
      });
  };

  var update = function(id, fieldToSave) {
    // convert dateObjects to strings
    //var fieldToSave = typeConversionSvc.toDb(field);
    if (fieldToSave.definition.type === 3 && fieldToSave.value) {
      //fieldToSave.value = fieldToSave.value.toUTCString();
      var dateToSave =
        fieldToSave.value.getFullYear() +
        '/' +
        (fieldToSave.value.getMonth() + 1) +
        '/' +
        fieldToSave.value.getDate();
      fieldToSave.value = dateToSave;
    }
    // update
    return resource.update(
      {
        id: id,
      },
      fieldToSave,
      function(response) {
        //var prevCompl = relBindSvc.relations[id].completeness;
        //relBindSvc.relations[id].completeness = response.completeness; //This is een object with an array "missingFields" and a number "percentage".

        if (response.relationsUsingAccountingNr && response.relationsUsingAccountingNr.length > 0) {
          var relations = response.relationsUsingAccountingNr.join(', ');
          flySvc.warning('msgRelationsWithSameAccountingNr', {
            p0: relations,
          });
          return;
        }

        if (response.relationsUsingCustomerCode && response.relationsUsingCustomerCode.length > 0) {
          var relations = response.relationsUsingCustomerCode.join(', ');
          flySvc.warning('msgRelationsSameCustomerCode', {
            p0: relations,
          });
          return;
        }

        flySvc.success('msgConfirmChange');

        // For fields where 2way binding is not working
        // var rel = relBindSvc.relations[id];
        // rel[fieldToSave.definition.id].value = fieldToSave.value;

        // update the relation with changes and billingErrors
        relBindSvc.updateRelation(id, response.changes, response.billingErrors, response.name);

        if (response.canUpdateInvoiceDiscounts) {
          dialogsSvc
            .showYesNo('msgUpdateDraftInvoicesTitle', 'msgApplyDiscountsToInvoices')
            .then(() => {
              resourceFactory.get('draftInvoice').recalculateDiscounts(
                {
                  id: id,
                },
                function(result) {
                  flySvc.message('msgXDraftInvoicesChanged', {
                    p0: result.result,
                  });
                },
                function(error) {
                  flySvc.error(error.data.code, error.data.parameters);
                },
              );
            });
        }
        if (response.fiscalYearsUpdated) {
          return recalcFiscalYearDeadlines(id);
        }
        if (typeof response?.changes?.companyId === 'string') {
          //CompanyId changed
          relBudgetSvc.reload(id);
        }
      },
      function(error) {
        flySvc.error(error.data.code, error.data.parameters, fieldToSave.definition.id);
      },
    ).$promise;
  };

  var save = function(fields) {
    // var fieldsToSave = typeConversionSvc.toDb(fields);
    var deferred = $q.defer();
    resource.save(
      {},
      fields,
      function(response) {
        deferred.resolve(response);
      },
      function(error) {
        flySvc.error(error);
        deferred.reject(error);
      },
    );
    return deferred.promise;
  };

  var remove = function(relId, name) {
    var deferred = $q.defer();
    resource.delete(
      {
        id: relId,
      },
      function(success) {
        var doRemove = true;
        var delFunc = function() {
          if (doRemove) {
            // in both cases: close relation file (if open) (= delete from relBindSvc)
            relBindSvc.close(relId);

            recentRelationsSvc.reloadRecentRelations();
            deferred.resolve();
          } else {
            deferred.reject();
          }
        };

        // Delete returns a boolean (that is put in success.result by tranform) to indicate if rel is set inactive instead of deleted
        if (success.result) {
          flySvc.proposal(
            'msgInactive_name',
            'Because of linked invoices/registrations.',
            function() {
              resource.undelete({
                id: relId,
              });
              doRemove = false;
            },
            'Undo/Make active',
            null,
            {
              name: name,
            },
          );
          delFunc();
        } else {
          flySvc.success('msgRemoved_name', {
            name: name,
          });
          delFunc();
        }
      },
      function(error) {
        flySvc.error(error.data.code, error.data.parameters);
        deferred.reject(error);
      },
    );

    return deferred.promise;
  };

  var getRequiredFields = function(type, crm, countryCode) {
    return fieldReqResource.query({
      type: type,
      crm: crm,
      country: countryCode,
    }).$promise;
  };
  var getWizardFields = function(type, crm, countryCode) {
    return fieldReqResource.wizard({
      type: type,
      crm: crm,
      country: countryCode,
    }).$promise;
  };
  var getSimilar = function(name, name2) {
    return resource.similar({
      id: name,
      id2: name2,
    }).$promise;
  };
  return {
    save: save,
    update: update,
    remove: remove,
    getRequiredFields: getRequiredFields,
    getSimilar: getSimilar,
    getWizardFields: getWizardFields,
    recalcFiscalYearDeadlines,
  };
}
